<template>
  <b-modal
    ref="scoutConfirmModal"
    id="scoutConfirmModal"
    modal-class="scout-confirm-modal"
    size="md"
    backdrop="static"
    centered
    hide-header
  >
  <div class="confirmation-content d-flex flex-column align-items-center">
    <h4 class="text-center" style="font-weight: bold;">スカウトを希望しますか？</h4>
    <p class="mt-4">
      この求人でスカウトを希望していることが企業に通知されます。<br />
      スカウト希望は3件まで可能です。（企業からのスカウトを確約するものではありません）
    </p>
  </div>
    <template #modal-footer>
      <div class="d-flex  w-100" style="justify-content: space-around">
        <b-button class="scout-button" @click="$emit('confirm')"
          >スカウトを希望する</b-button
        >
        <b-button class="next-button" @click="$emit('cancel')"
          >キャンセル</b-button
        >
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "ScoutConfirmationModal",
  methods: {
    show() {
      this.$refs.scoutConfirmModal.show();
    },
    hide() {
      this.$refs.scoutConfirmModal.hide();
    },
  },
};
</script>

<style scoped>
>>> .scout-confirm-modal .modal-footer {
  background: #f2f5f7 !important;
}
>>> .scout-confirm-modal .confirmation-content {
  padding: 50px 10px;
}

.text-center {
  text-align: center;
}
</style>
